type CaseSearchResultItem {
  id: ID!
  doctype: String!
  created_at: String
  modified_at: String
  owning_user_id: String
  owning_org_id: String
  owning_org_name: String
  regulating_org_id: String
  regulating_org_name: String
  client_ids: [String!]
  case_status: CaseStatus
  case_reason: MortgageReason
  address: CaseSearchAddress
  Clients: [CaseSearchResultClient!]
  GeneralInsurance: [CaseSearchResultGeneralInsurance!]
  Mortgages: [CaseSearchResultMortgage!]
  Protection: [CaseSearchResultProtection!]
}

type CaseSearchAddress {
  address1: String
  country: String
  post_town: String
  postcode: String
}

type CaseSearchResultClient {
  address1: String
  address2: String
  address3: String
  created_at: String
  credit_report_done: Boolean
  doctype: String
  email: String
  first_name: String
  id: String
  is_natural_person: Boolean
  last_name: String
  logged_in_to_client_portal: Boolean
  modified_at: String
  organisation_name: String
  phone_number: [String]
  postcode: String
  town: String
}

type CaseSearchResultGeneralInsurance {
  created_at: String
  doctype: String
  id: String
  modified_at: String
  policy_number: String
  status: String
}

type CaseSearchResultMortgage {
  assumes_continuing: [String]
  created_at: String
  doctype: String
  fees_added_to_loan: Boolean
  first_or_second_charge: Int
  id: String
  initial_payment: Float
  initial_rate: Float
  initial_rate_end_date: String
  initial_rate_type: String
  initial_term_days: Int
  lender: String
  lender_id: String
  modified_at: String
  mortgage_account_number: String
  mortgage_amount: Float
  mortgage_status: String
  mortgage_type: String
  offer_expiry_date: String
  part_and_part_amount: Float
  proc_fee: Float
  property_id: [String]
  repaid_date: String
  repayment_method: String
  revert_payment: Float
  revert_rate: Float
  source_rank: Int
  start_date: String
  term_months: Int
}

type CaseSearchResultProtection {
  benefit: [String]
  case_id: [String]
  client_id: [String]
  created_at: String
  doctype: String
  end_date: String
  id: String
  initial_commission: Float
  initial_commission_frequency: String
  initial_end_date: String
  modified_at: String
  policy_number: String
  product_name: String
  provider: String
  renewal_commission: Float
  renewal_commission_frequency: String
  renewal_end: String
  renewal_start: String
  solution_type: String
  start_date: String
  status: String
}

type CaseSearchResult {
  total_results: Int
  results: [CaseSearchResultItem!]
  link: String
  bookmark: Int
}

type CaseSearchQuery {
  searchFragment: String!
  bookmark: Int
}
